import { render } from "./AddUserDialog.vue?vue&type=template&id=ed8c3f12"
import script from "./AddUserDialog.vue?vue&type=script&lang=js"
export * from "./AddUserDialog.vue?vue&type=script&lang=js"
script.render = render

export default script